import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ImageWidgetV2: WidgetRegistryEntry = {
  name: "ImageV2",
  component: () => import("./image-widget-v2.component").then((m) => m.ImageWidgetV2Component),
  configuration: () => import("./configuration").then((m) => m.ImageWidgetV2Configuration)
};
